import { getAbschlussleistenAuswahlwerteForElemente } from "../../arrangement/Arrangement";
import { Farbmenuselect } from "./Farbmenuselect";
import { MAuswahlwert } from "../../../metamodell";

export function AbschlussLeistenOptionen() {
  return (
    <div key="abschluss-tabs" className="options-tab">
      <AbschlussleistenTab />
    </div>
  );
}

export function AbschlussleistenTab() {
  const agt = APP.arrangement;
  const möglicheAuswahlwerte: MAuswahlwert[] = getAbschlussleistenAuswahlwerteForElemente(
    agt.getSelectedOrAllElemente()
  );
  const auswahlwert: MAuswahlwert = agt.abschlussleisteAuswahlwert ?? möglicheAuswahlwerte[0];

  const { Abschlussleiste } = agt.auswahlAccessoren;
  return (
    <div>
      <div
        className="flex column-container"
        data-group-key="Abschlussleisten"
        data-select-key="Abschlussleisten"
        data-value={auswahlwert?.Key}
      >
        <Farbmenuselect
          auswahlwerte={möglicheAuswahlwerte}
          value={auswahlwert}
          onChange={Abschlussleiste.setter}
          className="pfosten-item"
        />
      </div>
    </div>
  );
}
